import { sungageApplicationErrorMessage } from "~/api/battery-sungage-application-errors"
import type { BatterySungageApplicationReadDto } from "~/api/dto/battery-proposal.dto"
import useBatterySungageApplication from "~/api/hooks/useBatterySungageApplication"
import useRefreshBatterySungageApplication from "~/api/hooks/useRefreshBatterySungageApplication"
import useResumeBatterySungageApplication from "~/api/hooks/useResumeBatterySungageApplication"

import {
  SUNGAGE_HOSTED_APPLICATION_EYEBROW,
  SUNGAGE_NO_APPLICATION_MESSAGE,
  SUNGAGE_PROVIDER,
} from "./sungage-battery-copy"
import {
  SungageApplicationStatus,
  type SungageApplicationStatusBundle,
} from "../../ProposalSetup/financing/sungage/SungageApplicationStatus"
import type { BatteryFinancingStatusExperienceProps } from "../financing-status/financing-status-experiences"

/**
 * Battery's reads and commands for the shared Sungage status: the BrightStart
 * application by id, Refresh and Resume on Battery's endpoints.
 */
const batterySungageStatusBundle: SungageApplicationStatusBundle<BatterySungageApplicationReadDto> =
  {
    testIdPrefix: `battery`,
    programLabel: () => `BrightStart`,
    hostedEyebrow: SUNGAGE_HOSTED_APPLICATION_EYEBROW,
    useApplication: useBatterySungageApplication,
    useRefresh: useRefreshBatterySungageApplication,
    useResume: useResumeBatterySungageApplication,
    describeError: sungageApplicationErrorMessage,
  }

export function SungageBatteryFinancingStatus({
  proposalId,
  financing,
}: BatteryFinancingStatusExperienceProps): JSX.Element {
  const current =
    financing.currentApplication?.provider === SUNGAGE_PROVIDER
      ? financing.currentApplication
      : null
  const previous = financing.previousApplications.find(
    (application) => application.provider === SUNGAGE_PROVIDER,
  )
  const applicationId = current?.id ?? previous?.id ?? null

  if (applicationId == null) {
    return (
      <p
        data-testid="battery-sungage-no-application"
        className="text-[length:var(--step--1)] text-bp-text-muted"
      >
        {SUNGAGE_NO_APPLICATION_MESSAGE}
      </p>
    )
  }

  return (
    <SungageApplicationStatus
      bundle={batterySungageStatusBundle}
      proposalId={proposalId}
      applicationId={applicationId}
      initial={null}
    />
  )
}
